export default class SandboxManager {
    constructor(api) {
        this.api = api;
    }

    getSandboxState = () => this.api.getSandboxState();

    createSandbox = () => this.api.createSandbox();

    getSandbox = () => this.api.getSandbox();
}
